// Vendor libs
import React, { useEffect, useState } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

// Components & Utils
import MealPlanApi from "../api/MealPlans";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";
import { Link } from "react-router-dom";

export default function ListRecMealPlans() {
  const [, dispatch] = useGlobalValue();
  const [mealPlans, setMealPlans] = useState([]);
  const [filteredMealPlans, setFilteredMealPlans] = useState([]);
  const [filter, setFilter] = useState(0);

  useEffect(() => {
    setIsLoading(true, dispatch);

    MealPlanApi.getRecurringMealPlans()
      .then(plans => {
        plans.sort((a, b) => {
          return a.start.isAfter(b.start) ? -1 : 1;
        });

        setMealPlans(plans);
        setIsLoading(false, dispatch);
      })
      .catch(apiErrors => {
        setErrors(apiErrors, dispatch);
        setIsLoading(false, dispatch);
      });
  }, [dispatch]);

  useEffect(() => {
    if (+filter === 0) {
      let newPlans = [];
      let today = moment();
      mealPlans.forEach(plan => {
        if (today.isBefore(plan.end)) {
          newPlans.push(plan);
        }
      });
      setFilteredMealPlans(newPlans);
    } else {
      setFilteredMealPlans(mealPlans);
    }
  }, [mealPlans, filter]);

  return (
    <div>
      <div className="row">
        <div className="col-sm-4">
          <h2>Recurring Meal Plans</h2>
        </div>
        <div className="col-sm-4">
          <Link to="/recmealplans/new" className="btn btn-block btn-outline-success">New Recurring Meal Plan</Link>
        </div>
        <div className="col-sm-4 text-right">
          <select className="form-control" onChange={e => setFilter(e.target.value)}>
            <option value={0}>Current Meal Plans</option>
            <option value={1}>All Meal Plans</option>
          </select>
        </div>
      </div>
      <br />
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th></th>
            <th>Menu</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody>
          {filteredMealPlans.map(plan => {
            return (
              <tr key={plan.id}>
                <td style={{ width: 35 }}>
                  <Link className="btn btn-info btn-sm btn-block" to={"/recmealplan/" + plan.id}>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Link>
                </td>
                <td>{plan.menu.name}</td>
                <td>{plan.start.format("DD/MM/YYYY")}</td>
                <td>{plan.end.format("DD/MM/YYYY")}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
